import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';

const APP_ROUTES: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'order-summary/:guid',
    loadChildren: () => import('./order-status-summary/order-status-summary.module').then(m => m.OrderStatusSummaryModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'apartment-complex/:id',
    loadChildren: () => import('./apartment-complex-information/apartment-complex-information.module').then(m => m.ApartmentComplexInformationModule),
  },
  {
    path: 'apartment-complex/:id/:section',
    loadChildren: () => import('./apartment-complex-information/apartment-complex-information.module').then(m => m.ApartmentComplexInformationModule),
  },
  {
    path: 'location/:id',
    loadChildren: () => import('./location/location.module').then(m => m.LocationModule),
  },
  {
    path: 'location-setup/new',
    loadChildren: () => import('./location-setup/location-setup.module').then(m => m.LocationSetupModule),
  },
  {
    path: 'apartment-complex/:complexID',
    loadChildren: () => import('./new-order/new-order.module').then(m => m.NewOrderModule),
  },
  {
    path: 'apartment-complex/:complexID/order-review',
    loadChildren: () => import('./order-review/order-review.module').then(m => m.OrderReviewModule),
  },
  {
    path: 'account1234',
    loadChildren: () => import('./account-creation/account-creation.module').then(m => m.AccountCreationModule),
  },
  {
    path: 'wizard',
    loadChildren: () => import('./guidelines-wizard/guidelines-wizard.module').then(m => m.GuidelinesWizardModule),
  },
  {
    path: 'wizard-es',
    loadChildren: () => import('./guidelines-wizard-spanish/guidelines-wizard-es.module').then(m => m.GuidelinesWizardEsModule),
  },
  {
    path: 'hinge-overlay-calculator',
    loadChildren: () => import('./hinge-overlay-calculator/hinge-overlay-calculator.module').then(m => m.HingeOverlayCalculatorModule),
  },
  {
    path: 'resend-orders',
    loadChildren: () => import('./resend-orders/resend-orders.module').then(m => m.ResendOrdersModule),
  },
  {
    path: 'resend-customer',
    loadChildren: () => import('./resend-customer/resend-customer.module').then(m => m.ResendCustomerModule),
  },
  // {
  //   path: "shopping-cart",
  //   loadChildren: () => import('./shopping-cart/shopping-cart.module').then(m => m.ShoppingCartModule),
  // },
  // {
  //   path: "shopping-cart/:isQuote",
  //   loadChildren: () => import('./shopping-cart/shopping-cart.module').then(m => m.ShoppingCartModule),
  // },
  {
    path: 'order-shopping-cart',
    loadChildren: () => import('./order-shopping-cart/order-shopping-cart.module').then(m => m.OrderShoppingCartModule),
  },
  {
    path: 'order-shopping-cart/:isQuote',
    loadChildren: () => import('./order-shopping-cart/order-shopping-cart.module').then(m => m.OrderShoppingCartModule),
  },
  {
    path: 'shopping-cart/modalv2',
    loadChildren: () => import('./shopping-cart/shopping-cart.module').then(m => m.ShoppingCartModule),
  },
  {
    path: 'statements',
    loadChildren: () => import('./statements/statement.download.module').then(m => m.StatementDownloadModule),
  },
  { path: '**', redirectTo: '/dashboard' },
];

export const routing = RouterModule.forRoot(APP_ROUTES);
